export enum SearchBy {
    Earliest = 1,
    Quickest = 2,
    Cheapest = 3,
    Region = 4,
    Port = 5,
    EarliestArrival = 6,
}
export enum UserRole {
    SuperAdmin = 1,
    User = 2
}

export enum RateRequestStatus {
    Pending = 1,
    Confirmed = 2,
    Rerequest = 3
}

export enum UserSelectedPlan {
    Basic = 1,
    Advanced = 2,
    Pro = 3,
    ProPlus = 4,
    Elite = 5
}

export enum PlanPermissions {
    SimpleSearch = 1,
    QuickestSearch = 2,
    PriceSearch = 3,
    FullPortCalendar = 4,
    FreigthQuotations = 5,
    Analytics = 6,
    Tracking = 7
}

export enum PagePermission {
    Searchresult = 'searchresult',
    Portcalendar = 'portcalendar',
    Raterequestlist = 'raterequestlist',
    Bookinglist = 'bookinglist',
    Voyagedetail = 'voyagedetail',
    Raterequest = 'raterequest',
    Bookingdetail = 'bookingdetail',
    Tracking = 'tracking',
    TrackingVoyage = 'trackingvoyage',
    Analytics = 'analytics'
}

export enum DefaultPort {
    PortName = 'Bremerhaven'
}
export enum DefaultPortVoyagePerformance {
    Bremerhaven = 6057,
    Singapore = 13247
}

export enum DefaultRegion {
    NorthernAfrica = 1,
    EasternAfrica = 2
}

export enum RaterequestStatus {
    All = 0,
    AwaitingOffers = 1,
    OfferReceived = 2,
    AwaitingBookingConfirmation = 3,
    BookingConfirmed = 4,
    ReRequest = 5
}
export enum RateStatus {
    All = 0,
    AwaitingBookingConfirmation = 3,
    BookingConfirmed = 4,
}

export enum ShippingLineRroute {
    Direct = 0,
    Transhipment = 1
}

export enum PlanSubcriptions {
    Active = 1,
    Canceled = 2,
    Suspended = 3
}

export enum UpgradedMethods {
    Paypal = 1,
    Manual = 2
}

export enum BookingFeeAndLumpsum {
    Lumpsum = 4,
    BookingFee = 25
}

export enum DataParam{
    LandingPageSearch = "LandingPageSearch",
    VoyageTrackerSearch = "VoyageTrackerSearch",
    PortcalendarSearch = "PortcalendarSearch"
}

export enum DurationFilter{
    SixMonths = 1,
    OneYears = 2,
    TwoYears = 3,
    ThreeYears = 4,
    FiveYears = 5,
    All = 6,
}

export const GetDurationFilterValues: Record<DurationFilter, string> = {
    [DurationFilter.SixMonths]: "Last six months",
    [DurationFilter.OneYears]: "Last year",
    [DurationFilter.TwoYears]: "Last two years",
    [DurationFilter.ThreeYears]: "Last three years",
    [DurationFilter.FiveYears]: "Last five years",
    [DurationFilter.All]: "All",
};

export enum OpenSearchScreen{
    Finder = "ROUTEFINDER",
    Tracker = "SHIPMENTTRACKER",
    PortActivities = "PORTACTIVITIES",
    RateRequest = "RATEREQUEST"
}

export enum OpenSearchFinderFields{
    FromCountry = "FromCountry",
    FromPort = "FromPort",
    ToCountry = "ToCountry",
    ToPort = "ToPort",
    Vessel = "Vessel",
    Shippingline = "Shippingline",
    Port = "Port",
}

export enum NewsStaticRoute{
  Url='https://blog.enl.solutions/',
}

export enum VoyagePageData{
  MetaName="description",
  MetaContent="Route Finder is an online tool to help you find RoRo and PCTC shipping lines available to transport your cargo. Get details of departure & arrival schedules, ports, rates and more.",
}



